import React from "react"
import { Provider } from "react-redux"
import createStore from "./src/state/createStore"
import { AiOutlineConsoleSql } from "react-icons/ai"

const store = createStore()

export default ({ element }) => <Provider store={store}>{element}</Provider>
